import { useEffect } from 'react'

import RunnerGL from '@/components/Runner/RunnerGL'
import RunnerUI from '@/components/Runner/RunnerUI'
import { useAppState } from '@/composables/useAppState'
import useTracking from '@/composables/useTracking'

export default function Runner() {
  const { trackImpression } = useTracking()
  const { scenarioUnitName, persona } = useAppState()

  useEffect(() => {
    trackImpression({
      unitName: `${persona}_simulation${scenarioUnitName}`,
      unitVariation: 'runner_start',
      unitLocation: 'tyce',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scenarioUnitName])

  return (
    <div data-testid='runner' className='col-span-1 col-start-1 row-span-1 w-full min-h-dvh md:h-screen'>
      <RunnerGL className='glcontainer z-0' />
      <RunnerUI />
    </div>
  )
}
